module.exports = __webpack_public_path__ + "img/ltkworkwear-4x.4cddb53.jpg";